import { Box } from '@mui/material'
import { Edit20Regular, MoreHorizontal20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function UserChatBubbleFloatingEditMore({
  showEditAction,
  onEdit,
  moreMenuAnchor,
  setReactionPickerAnchorEl,
  setMoreMenuAnchor,
}) {
  return (
    <>
      {showEditAction ? (
        <>
          <span className={styles.floatingBarDivider} aria-hidden />
          <Tooltip text={onEdit ? 'Edit message' : 'Edit unavailable'} placement="top">
            <Box component="span" sx={{ display: 'inline-flex' }}>
              <button
                type="button"
                className={styles.floatingIconButton}
                aria-label="Edit message"
                disabled={!onEdit}
                onClick={() => onEdit?.()}
              >
                <Edit20Regular aria-hidden />
              </button>
            </Box>
          </Tooltip>
        </>
      ) : null}
      <Tooltip text="More" placement="top">
        <button
          type="button"
          className={styles.floatingIconButton}
          aria-haspopup="true"
          aria-expanded={Boolean(moreMenuAnchor)}
          aria-label="More actions"
          onClick={(event) => {
            setReactionPickerAnchorEl(null)
            setMoreMenuAnchor(event.currentTarget)
          }}
        >
          <MoreHorizontal20Regular aria-hidden />
        </button>
      </Tooltip>
    </>
  )
}
